import { useState, useCallback } from 'react';

interface UseFormFieldsReturn {
    formData: Record<string, any>;
    displayValues: Record<string, string>;
    rawValues: Record<string, any>;
    setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
    setDisplayValues: React.Dispatch<React.SetStateAction<Record<string, string>>>;
    setRawValues: React.Dispatch<React.SetStateAction<Record<string, any>>>;
    handleInputChange: (code: string, value: any) => void;
    resetFormData: () => void;
}

export const useFormFields = (initialData: Record<string, any> = {}): UseFormFieldsReturn => {
    const [formData, setFormData] = useState<Record<string, any>>(initialData);
    const [displayValues, setDisplayValues] = useState<Record<string, string>>({});
    const [rawValues, setRawValues] = useState<Record<string, any>>({});

    const handleInputChange = useCallback((code: string, value: any) => {
        setFormData(prev => ({
            ...prev,
            [code]: value
        }));
    }, []);

    const resetFormData = useCallback(() => {
        setFormData({});
        setDisplayValues({});
        setRawValues({});
    }, []);

    return {
        formData,
        displayValues,
        rawValues,
        setFormData,
        setDisplayValues,
        setRawValues,
        handleInputChange,
        resetFormData
    };
};